import type { TelemetrySink } from "@stockline/web";
import { trackOperational } from "@/lib/analytics";

/**
 * Bridges the offline SyncEngine's operational events into PostHog. Injected
 * into `AISyncProvider` (which lives in `@stockline/web` and can't import the
 * analytics module directly). Every event funnelled here automatically rides
 * the per-tenant super properties + `company` group registered at login, so
 * `offline.db_closed` / `sync.resync.*` / `sync.reconnect` are all filterable
 * by tenant without any extra tagging.
 */
export const offlineTelemetrySink: TelemetrySink = {
  track: (event, props) => trackOperational(event, props),
};
